import type { GetLalSegmentsBuildAudienceQuery } from '../../../../../../../graphql/query/audiences/GetLalSegmentsBuildAudience.generated';
import type { LookalikeSegmentDefinition, SimilarityLevelValue } from '../../../../types';

type RawLalDefinition = GetLalSegmentsBuildAudienceQuery['lalSegmentFeed'];

export const transformLalDefinitions = (
  accountId: string,
  definitions: RawLalDefinition | undefined
): LookalikeSegmentDefinition[] => {
  const rawData = definitions || [];

  return rawData.map(item => ({
    id: item.id,
    account_id: accountId,
    provider_id: item.provider_id,
    lookalike_name: item.lookalike_name,
    status: item.status,
    created_date: item.created_date,
    updated_date: item.updated_date,
    lookalike_segment_seed_aggregate: item.lookalike_segment_seed_aggregate
      ? {
          segment: {
            id: item.lookalike_segment_seed_aggregate.segment.id,
            account_id: accountId,
            provider_id: item.lookalike_segment_seed_aggregate.segment.provider_id,
            name: item.lookalike_segment_seed_aggregate.segment.name,
            status: item.lookalike_segment_seed_aggregate.segment.status,
            external_id: item.lookalike_segment_seed_aggregate.segment.external_id,
            expiration_date: item.lookalike_segment_seed_aggregate.segment.expiration_date,
            lookalike_definition_id: item.id,
            reach: item.lookalike_segment_seed_aggregate.segment.reach,
            description: '',
            sellable: false,
          },
        }
      : undefined,
    lookalike_segment_similarities: (item.lookalike_segment_similarities || []).map(similarityDefinition => ({
      similarity_level: similarityDefinition.similarity_level as SimilarityLevelValue,
      segment: {
        id: similarityDefinition.segment.id,
        account_id: accountId,
        provider_id: similarityDefinition.segment.provider_id,
        name: similarityDefinition.segment.name,
        status: similarityDefinition.segment.status,
        external_id: similarityDefinition.segment.external_id,
        expiration_date: similarityDefinition.segment.expiration_date,
        lookalike_definition_id: item.id,
        reach: similarityDefinition.segment?.reach,
        propensity: similarityDefinition.similarity_level as SimilarityLevelValue,
        description: '',
        sellable: false,
      },
    })),
  }));
};
